<app-dialog [headerGlyph]="config.headerGlyph" [headerText]="config.title" [saveText]="config.confirmText"
            [showTopCancelButton]="!!config.cancelText" [showCancelButton]="!!config.cancelText" [cancelText]="config.cancelText" saveButtonType="transparent" (save)="dialogRef.close('Close')"
            [body]="body">
    <ng-template #body>
        <div class="container">
            <div [innerHTML]="config.bodyText"></div>
        </div>
    </ng-template>
</app-dialog>

